/*
 * @Author: Chen Zhen
 * @Date: 2020-01-06 15:18:36
 * @LastEditors  : Nie Wie
 * @LastEditTime : 2020-02-16 23:11:58
 * @Description: 按需饮用 lodash
 */

const _ = require('lodash/core')

_.isNil = require('lodash/isNil')

_.isElement = require('lodash/isElement')

_.cloneDeep = require('lodash/cloneDeep')

_.throttle = require('lodash/throttle')

_.padStart = require('lodash/padStart')

_.defaultsDeep = require('lodash/defaultsDeep')

_.defaultsDeep = require('lodash/defaultsDeep')

_.take = require('lodash/take')

global._ = _
